"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Button = styled_components_1["default"].button(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  background: ", ";\n  color: ", ";\n  border: 0;\n  padding: 1em 2em;\n  font-size: 16px;\n  text-transform: uppercase;\n  text-align: center;\n  border-radius: 4px;\n  font-weight: bold;\n  cursor: pointer;\n  width: 100%;\n\n  ", ";\n"], ["\n  background: ", ";\n  color: ", ";\n  border: 0;\n  padding: 1em 2em;\n  font-size: 16px;\n  text-transform: uppercase;\n  text-align: center;\n  border-radius: 4px;\n  font-weight: bold;\n  cursor: pointer;\n  width: 100%;\n\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.button.backgroundColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.button.color;
}, function (_a) {
    var theme = _a.theme;
    return theme.media.m(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    font-size: 14px;\n    width: auto;\n  "], ["\n    font-size: 14px;\n    width: auto;\n  "])));
});
exports["default"] = Button;
var templateObject_1, templateObject_2;
